var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-backtop',{attrs:{"bottom":30}},[_c('div',{staticStyle:{"{\n\t    height":"100%","width":"100%","background-color":"#f2f5f6","box-shadow":"0 0 6px rgba(0,0,0, .12)","border-radius":"5px","text-align":"center","line-height":"40px","color":"#1989fa"}},[_vm._v("top")])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }